/**
 * Splice live values into a translated sentence at its `{name}` placeholders, returning the
 * pieces for Lit's `html` to interpolate (it handles strings, `TemplateResult`s and raw
 * `Node`s alike). `t()` leaves a placeholder it got no param for intact, which is exactly
 * what lets "Run for {days} days" carry its control in translated word order - the WHOLE
 * sentence stays one i18n key, and the control (a `<select>`, an in-app nav `<a @click>`)
 * lands wherever the translator put the placeholder.
 *
 * Extracted from `pages/content.ts` in round 80 when the release workspace's Ads panel
 * became its second consumer (it splices `<a @click>` nav links into the panel's lead and
 * empty-state sentences, where a plain `richText()` hash link would not route - this
 * router navigates through `navigateTo`, not hashchange). Content.ts splices form controls;
 * both are the same mechanism.
 */
export function withNodes(text: string, nodes: Record<string, unknown>): unknown[] {
	const out: unknown[] = [];
	const pattern = /\{(\w+)\}/g;
	let last = 0;
	let match: RegExpExecArray | null;
	while ((match = pattern.exec(text)) !== null) {
		out.push(text.slice(last, match.index));
		out.push(match[1] in nodes ? nodes[match[1]] : match[0]);
		last = match.index + match[0].length;
	}
	out.push(text.slice(last));
	return out;
}
